/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CandidateStatusDto = {
    SentToERecruiter: 'SENT_TO_E_RECRUITER',
    PositiveFeedback: 'POSITIVE_FEEDBACK',
    NegativeFeedback: 'NEGATIVE_FEEDBACK',
    PositiveFeedbackSent: 'POSITIVE_FEEDBACK_SENT',
    NegativeFeedbackSent: 'NEGATIVE_FEEDBACK_SENT',
    InQuiz: 'IN_QUIZ',
    QuizFinished: 'QUIZ_FINISHED',
    QuizExpired: 'QUIZ_EXPIRED',
    QuizRevisitsExceeded: 'QUIZ_REVISITS_EXCEEDED',
    QuizPointsResultReady: 'QUIZ_POINTS_RESULT_READY',
    PersonalDataProvided: 'PERSONAL_DATA_PROVIDED',
    CandidateProcessFinished: 'CANDIDATE_PROCESS_FINISHED',
    EmailProvided: 'EMAIL_PROVIDED',
    EmailVerified: 'EMAIL_VERIFIED'
} as const;

export type CandidateStatusDto = typeof CandidateStatusDto[keyof typeof CandidateStatusDto];



